import {
  createAuthContext,
  useAuth as useWebKitAuth,
  type AuthContextValueT,
} from '@lotushealth/web_kit/auth';

import type { SessionUser } from '@/entities/session';

export type User = SessionUser;

export type AuthContextValue = AuthContextValueT<User>;

export const AuthContext = createAuthContext<User>();

export function useAuth(): AuthContextValue {
  return useWebKitAuth(AuthContext);
}
